<template>
  <div class="review-table">
    <spinner v-if="loading" />
    <h2>Review and comment Links</h2>
    <slot-table v-if="reviewAndCommentsLinks" :tableData="reviewAndCommentsLinks.items"
                :data="reviewAndCommentsLinks.items" :columns="table.columns">

      <template slot="client" slot-scope="props">
          <span>
            <router-link :to="{ path: `/client/${props.item.creative.campaign.client.hash_id}` }">
              {{ props.item.creative.campaign.client.name }}
            </router-link>
          </span>
      </template>

      <template slot="campaign" slot-scope="props">
          <span>
            <router-link :to="{ path: `/campaigns/${props.item.creative.campaign.hash_id}` }">
              {{ props.item.creative.campaign.name }}
            </router-link>
          </span>
      </template>

      <template slot="creative" slot-scope="props">
          <span>
            <router-link :to="{ path: `/creatives/${props.item.creative.hash_id}/bulk` }">
              {{ props.item.creative.name }}
            </router-link>
          </span>
      </template>

      <template slot="status" slot-scope="props">
          <span :class="statusCss(props.item)">
            {{ statusText(props.item) }}
          </span>
      </template>

      <template slot="date" slot-scope="props">
        <span>{{ props.item.date_created.value | formatDateTime }} </span>
      </template>

      <template slot="linkActions" slot-scope="props" v-if="!props.item.deleted">
        <a class="btn btn-primary btn-xs" :href="previewUrl(props.item)" target="_blank"
           title="Launch Review Link"><i class="fa fa-eye" aria-hidden="true"></i></a>
        <button-cta title="Edit Review link name" data-modalType="editLink" :data-modalField="props.item.name"
                    :data-modalID="props.item.hash_id" :onClick="showModalHandler"
                    :data-modalFieldType="'review-and-comments'"
                    class="btn btn-warning btn-xs">
          <i class="fa fa-pencil" aria-hidden="true"></i>
        </button-cta>
        <button-cta title="Delete Review Link" data-modalType="deleteLink" :data-modalID="props.item.hash_id"
                    :onClick="showModalHandler"
                    :data-modalFieldType="'review-and-comments'"
                    class="btn btn-danger btn-xs">
          <i class="fa fa-trash" aria-hidden="true"></i>
        </button-cta>
        <button-cta title="Clone Review Link" data-modalType="createPreviewLink" :data-modalID="props.item.hash_id" v-if="props.item.feedback_submitted==true"
                    :onClick="validateCloneProcess"
                    :data-modalField="props.item.name"
                    :data-modalFieldType="'review-and-comments'"
                    :data-hashid="props.item.hash_id"
                    class="btn btn-success btn-xs">
          <i class="fa fa-copy" aria-hidden="true"></i>
        </button-cta>
        <button-cta title="Export Review Link" data-modalType="deleteLink" :data-modalID="props.item.hash_id"
                    :onClick="generateExcelReport"
                    :data-hashid="props.item.hash_id"
                    :data-modalFieldType="'review-and-comments'"
                    class="btn btn-info btn-xs">
          <i class="fa fa-download" aria-hidden="true"></i>
        </button-cta>
      </template>

    </slot-table>
    <div class="row" v-if="showPager">
      <div class="col-sm-6">
      </div>
      <div class="col-sm-6">
        <pager :pagerData="reviewAndCommentsLinks"
               :onPaginate="onPaginate"
               :onChangePageSize="onChangePageSize"
               :minItemsPerPage="reviewAndCommentsLinks.pageSize"
               ref="pagerRef"
        />
      </div>
    </div>
    <div class="cnt-buttons">
      <button class="btn btn-primary"
              @click="goFullList"
              v-if="!showPager"
      >
        View all
      </button>
    </div>
  </div>
</template>

<script>

import HeadingWrap from '@/components/HeadingWrap/heading-wrap'
import SlotTable from '@/components/Table/table'
import ButtonCta from '@/components/Button/button'

import Pager from '@/components/Pager/pager'
import Tooltip from '@/components/Tooltip/tooltip'
import {linkMixin, LINKS_TABLE_TYPES} from '@/mixins/linkMixin'

import {downloadMixin} from '@/mixins/downloadMixin'
import Spinner from '@/components/SpinnerIcon/spinner'
import {modalMixin} from '@/mixins/modalMixin'

import {authMixin} from '@/mixins/authMixin'
import {API_URL} from '@/config'

export default {
  name: 'table-links-review-comments',
  mixins: [linkMixin, downloadMixin, modalMixin, authMixin],
  components: {HeadingWrap,
    SlotTable,
    ButtonCta,
    Pager,
    Tooltip,
    Spinner
  },
  props: {
    showPager: Boolean,
    showModalHandler: Function,
    cloneReviewHandler: Function
  },
  data: () => ({
    search: '',
    table: {
      columns: {
        name: 'Name',
        date: 'Date Created',
        client: 'Client',
        status: 'Status',
        campaign: 'Campaign Name',
        creative: 'Creative Name',
        linkActions: ''
      },
      statusKeys: {
        rendered: 'success',
        under_review: 'warning',
        edited: 'info',
        error: 'danger',
        queued: 'warning'
      }
    }
  }),
  mounted () {
    this.setPagerData({type: LINKS_TABLE_TYPES.REVIEW_AND_COMMENTS, pageSize: this.showPager ? 50 : 10})
    this.getLinks(LINKS_TABLE_TYPES.REVIEW_AND_COMMENTS).then(() => {
    })
  },
  methods: {
    previewUrl (item) {
      const path = `/review/feedback/${item.hash_id}`
      const unescape = window.unescape || window.decodeURI

      return API_URL + path.substring(1) + `?token=${btoa(unescape(encodeURIComponent(this.getAccessToken)))}`
    },
    onPaginate (page) {
      this.setPagerData({type: LINKS_TABLE_TYPES.REVIEW_AND_COMMENTS, page})
      this.getLinks(LINKS_TABLE_TYPES.REVIEW_AND_COMMENTS)
    },
    onChangePageSize (pageSize) {
      this.setPagerData({type: LINKS_TABLE_TYPES.REVIEW_AND_COMMENTS, pageSize})
      this.getLinks(LINKS_TABLE_TYPES.REVIEW_AND_COMMENTS)
    },
    goFullList () {
      this.$router.push({name: 'ReviewLinksType', params: {type: LINKS_TABLE_TYPES.REVIEW_AND_COMMENTS}})
    },
    statusCss (item) {
      let labelType = 'warning'
      if (item.deleted) labelType = 'danger'
      if (item.feedback_submitted === true) labelType = 'success'
      return `label label-${labelType} text-center text-capitalize`
    },
    statusText (item) {
      if (item.deleted) return 'DELETED'
      if (item.feedback_submitted === true) return 'FEEDBACK SUBMITTED'
      return 'PENDING'
    },
    generateExcelReport (evt) {
      this.startLoading()
      this.createSignedDownloadRequest({
        domain: 'review-link-report',
        resource: evt.currentTarget.dataset.hashid,
        extension: 'xlsx'
      }).then(response => {
        this.finishLoading()
        if (!response.success) {
          alert('Try again later')
          return
        }
        window.open(API_URL + response.link.substring(1))
      }).catch(reason => {
        this.finishLoading()
        alert(reason)
      })
    },
    validateCloneProcess (evt) {
      this.cloneReviewHandler(evt)
    }
  }
}
</script>

<style lang="scss">
.review-table {
  h2 {
    margin-bottom: 22px;
    font-size: 22px;
  }

  .cnt-buttons {
    margin-bottom: 54px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/LinksReviewComments/table-links-review-comments.vue